import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';
import { FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import DeviceIcon from '../../../../../components/assets/icons/deviceIcon';
import { Device } from '../../../../../types/device';

interface Props {
  devices: Device[] | undefined;
  onChange: (value: Device['serialNumber'] | null) => void;
  value: Device['serialNumber'] | null;
  error?: FieldError;
  disabled?: boolean;
}

const DeviceSelect: FC<Props> = ({ devices, onChange, value, error, disabled }) => {
  const { t } = useTranslation('registrations');
  const theme = useTheme();

  return (
    <Autocomplete
      filterOptions={createFilterOptions({
        ignoreCase: true,
        trim: true
      })}
      disabled={disabled}
      inputValue={value ?? ''}
      isOptionEqualToValue={(item) => item?.serialNumber === value}
      freeSolo
      onInputChange={(event, newInputValue) => {
        onChange(newInputValue);
      }}
      id="devices-select"
      sx={{
        background: theme.palette.trueWhite.main
      }}
      options={devices ?? []}
      autoHighlight
      getOptionLabel={(option) => (typeof option === 'string' ? option : option?.serialNumber)}
      renderOption={(props, option) => (
        <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props} key={option.serialNumber}>
          <DeviceIcon />
          {`${option.serialNumber} / ${option.articleName}`}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={t('registrations.general.enterSerialNumber')}
          inputProps={{
            ...params.inputProps
          }}
          error={!!error?.message}
          helperText={error?.message}
        />
      )}
    />
  );
};

export default DeviceSelect;
